import type { ComponentProps, ComponentType, PropsWithChildren } from 'react';

import { Focusable, Tooltip, TooltipTrigger } from '@iconik-io/uad';

export type StatusTooltipProps = PropsWithChildren<{
  label: string;
  /** Where the tooltip opens relative to the status. Defaults to `bottom`. */
  placement?: ComponentProps<typeof Tooltip>['placement'];
}>;

export type StatusTooltipComponent = ComponentType<StatusTooltipProps>;

export function StatusTooltip({
  label,
  placement = 'bottom',
  children,
}: StatusTooltipProps) {
  return (
    <TooltipTrigger>
      <Focusable excludeFromTabOrder>
        <div role="status" aria-label={label}>
          {children}
        </div>
      </Focusable>
      <Tooltip placement={placement}>{label}</Tooltip>
    </TooltipTrigger>
  );
}
